export const sanitiseName = (name: string): string =>
    name.replace(/[^a-zA-Z0-9 ]/g,'')
